// Import PGBA common plugin
import PgbaCommonPlugin from '../common/PgbaCommonPlugin';

import Vue from 'vue';
import Vuex from 'vuex';

// Import component parsing utility
import ComponentParser from '../util/ComponentParser';

// Import bootstrap vue components
import BootstrapVue from 'bootstrap-vue';

// Import custom footer components
import Footer from './components/Footer.vue';

// Import footer resources
import {getStore} from './footer-resources';

// Register framework libraries
Vue.use(Vuex);
Vue.use(BootstrapVue);
Vue.use(PgbaCommonPlugin);

const store = getStore();

ComponentParser.parse('pgba-footer', Footer, { store });
